import { Head, Link, router } from "@inertiajs/react"
import {
  Box, Button, Paper, Stack, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Typography
} from "@mui/material"
import AdminLayout from "../../../layouts/AdminLayout"

type Topic = {
  id: number
  name: string
  slug: string
  summary: string | null
  jp: string | null
  banner_url: string | null
}

export default function AdminTopicsIndex({ topics }: { topics: Topic[] }) {
  const remove = (topic: Topic) => {
    if (confirm(`Delete topic "${topic.name}"?`)) router.delete(`/admin/topics/${topic.slug}`)
  }

  return (
    <AdminLayout title="Topics" maxWidth={false}>
      <Head title="Admin · Topics" />
      <Stack direction="row" sx={{ justifyContent: "space-between", mb: 2 }}>
        <Typography variant="h5">Topics</Typography>
        <Button variant="contained" component={Link} href="/admin/topics/new" data-testid="new-topic">
          New topic
        </Button>
      </Stack>
      {topics.length === 0 ? (
        <Box sx={{ p: 4, textAlign: "center" }} data-testid="topics-empty">
          <Typography>No topics yet. Create your first one!</Typography>
        </Box>
      ) : (
        <TableContainer component={Paper}>
          <Table data-testid="topics-table">
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Japanese</TableCell>
                <TableCell>Summary</TableCell>
                <TableCell>Banner</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {topics.map((topic) => (
                <TableRow key={topic.id} data-testid={`topic-row-${topic.id}`}>
                  <TableCell>
                    <Link href={`/admin/topics/${topic.slug}`}>{topic.name}</Link>
                  </TableCell>
                  <TableCell>{topic.jp || "—"}</TableCell>
                  <TableCell>{topic.summary || "—"}</TableCell>
                  <TableCell>
                    {topic.banner_url ? (
                      <img src={topic.banner_url} alt="" style={{ height: 32 }} />
                    ) : "—"}
                  </TableCell>
                  <TableCell align="right">
                    <Stack direction="row" spacing={1} sx={{ justifyContent: "flex-end" }}>
                      <Button size="small" component={Link} href={`/admin/topics/${topic.slug}/edit`}>Edit</Button>
                      <Button size="small" color="error" onClick={() => remove(topic)}
                              data-testid={`delete-${topic.id}`}>Delete</Button>
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </AdminLayout>
  )
}
